<template>
    <div id="app">
        <main-header nowtab="play"></main-header>
        <main class="adjuster">
            <a-card size="small" class="card dashboard-card">
                <a-row :gutter="8">
                    <a-col :span="5">
                        <a-radio-group v-model="sortmode" @change="onChange">
                            <a-radio-button value="hotest">
                                最热
                            </a-radio-button>
                            <a-radio-button value="latest">
                                最新
                            </a-radio-button>
                        </a-radio-group>
                    </a-col>
                    <a-col :span="14">
                        <a-input-search v-model="searchstr" placeholder="查找魔塔" enter-button @search="search()" />
                    </a-col>
                    <a-col :span="5" class="advanced-filter-btn">
                        <a-checkable-tag :checked="advancedFilter" @change="toggleFilter">高级筛选</a-checkable-tag>
                    </a-col>
                </a-row>
                <div class="advanced-filter" style="height:0px" ref="advancedFilter">
                    按标签筛选:
                    <a-checkable-tag
                        v-for="tag in tags" :key="tag"
                        :checked="selectedTags.indexOf(tag) > -1"
                        @change="checked => handleSelectTag(tag, checked)"
                    >
                        {{ tag }}
                    </a-checkable-tag>
                    <a-tag @click="selectAll">全选</a-tag>
                    <a-tag @click="clearTags">清空</a-tag>
                    <br/>
                    <!-- 按目录筛选:
                    <a-checkable-tag></a-checkable-tag> -->
                </div>
                <a-row :gutter="8">
                    <a-col class="color-select" :offset="5" :span="14">
                        <span class="colormode" :style="{ color: colormodenow.color }">
                            {{ colormodenow.description }}
                            <span v-for="mode of leftcolors" :key="mode.key" 
                                :style="{ color: mode.color }" class="switch"
                                @click="changeColor(mode.key)"
                            >{{ mode.name }}</span>
                        </span>
                        <a class="color-helper" @click="colorHelp" href="javascript:void 0">
                            <a-icon type="question-circle" />颜色系统是什么
                        </a>
                    </a-col>
                    <a-col :span="5" class="extra">
                        <a class="el-link" href="/record.html" target="_blank">提交记录</a>
                        <a class="el-link" href="javascript:void 0" @click="switchCard">切换卡片</a>
                    </a-col>
                </a-row>
            </a-card>
            <a-pagination :current="Number(page)" :total="Number(total)" 
                :defaultPageSize="20" @change="turnPage" :hideOnSinglePage="true"
            />
            <div>
                <a class="rand" href="javascript:void 0" @click="loadRandomList">不满意？换一批！</a>
            </div>
            <a-spin :spinning="loading" class="tower-list-container">
                <ul class="tower-list">
                    <main-tower-card
                        v-for="tower of towers" :key="tower.name" :tower="tower" :useold="useold"
                    />
                </ul>
            </a-spin>
            <a-pagination :current="Number(page)" :total="Number(total)" 
                :defaultPageSize="20" @change="turnPage" :hideOnSinglePage="true"
            />
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue';
import Footer from '@/components/Footer.vue';
import MainTowerCard from '../../components/MainTowerCard.vue';
import { TAGS } from '../../constant';
import { createFormData, transitionAttr } from '../../utils/utils';
import axios from 'axios';

const COLOR_MODES = [
    { key: '2|3', name: '蓝绿区', description: '当前位于蓝绿区', color: '#008000' },
    { key: '1|4', name: '红橙区', description: '当前位于红橙区', color: '#FF0000' },
    { key: '0|5', name: '白紫区', description: '当前位于白紫区', color: '#800080' },
    { key: '#', name: '所有塔', description: '当前显示所有塔', color: '#000000' },
];

export default {
    data: () => ({
        page: 1,
        total: 0,
        sortmode: 'hotest',
        colormode: '#',
        searchstr: "",
        tags: TAGS,
        advancedFilter: false,
        selectedTags: [],
        loading: false,
        towers: [],
        searchHandle: null,
        useold: localStorage.getItem("website.useoldcard") == "1",
    }),
    computed: {
        colormodenow() {
            return COLOR_MODES.find(e => e.key == this.colormode);
        },
        leftcolors() {
            return COLOR_MODES.filter(e => e.key != this.colormode);
        },
    },
    created() {
        const url = new URLSearchParams(window.location.search);
        // this.searchstr = url.has("q") ? url.get("q") : "";
        this.search();
    },
    methods: {
        turnPage(page) {
            this.page = page;
            this.search(true);
        },
        onChange() {
            this.search();
        },
        colorHelp() {
            this.$info({
                title: '颜色系统说明',
                content: h => (
                    <div>
                        <table border="1" cellspacing="0" style="text-align:center">
                            <tbody>
                                <tr><td colspan="2" rowspan="2"><b>颜色标注</b></td><td colspan="3"><b>游戏体验感</b></td></tr>
                                <tr><td>良好</td><td>一般</td><td>较差</td></tr>
                                <tr><td rowspan="2"><b>难度</b></td><td>较难</td><td style="background:lightgreen">浅绿</td><td style="background:#FFC088">浅橙</td><td style="background:#FF9999">浅红</td></tr>
                                <tr><td>一般</td><td style="background:lightblue">浅蓝</td><td style="rgba(252,252,252,0.2)">无色</td><td style="background:#ded0ff">淡紫</td></tr>
                            </tbody>
                        </table>
                        <p></p>
                        <p>
                            <b>游戏体验感：</b>主要面向广大休闲玩家。
                        </p>
                        <ul>
                            <li>良好：美工、剧情或创新等方面较为突出，能吸引人（尤其是广大休闲玩家）玩下去。</li>
                            <li>一般：中规中矩，并不突出，但是也不让人感到不适。</li>
                            <li>较差：让人感到不适，比如满屏阻激夹域血网自爆等恶心属性，或者界面比较瞎眼。</li>
                        </ul>
                        <b>难度：</b>主要面向有一定拆塔水平的硬核玩家。
                        <ul>
                            <li>较难：最高难度通关有一定的难度，或者比较具有研究价值。</li>
                            <li>一般：难度不是特别高，也不怎么具有反复研究的价值。</li>
                        </ul>
                    </div>
                ),
                onOk() {},
            });
        },
        handleSelectTag(tag, checked) {
            const { selectedTags } = this;
            const nextSelectedTags = checked
                ? [...selectedTags, tag]
                : selectedTags.filter(t => t !== tag);
            this.selectedTags = nextSelectedTags;
            this.search();
        },
        selectAll() {
            if (this.selectedTags.length < this.tags.length) {
                this.selectedTags = [ ...this.tags ];
                this.search();
            }
        },
        clearTags() {
            if (this.selectedTags.length > 0) {
                this.selectedTags = [];
                this.search();
            }
        },
        toggleFilter() {
            if (this.advancedFilter) {
                transitionAttr(this.$refs.advancedFilter, "height", "0px", 300);
                this.clearTags();
            } else {
                transitionAttr(this.$refs.advancedFilter, "height", "auto", 300);
            }
            this.advancedFilter = !this.advancedFilter;
        },
        changeColor(color) {
            this.colormode = color;
            this.search();
        },
        async loadRandomList() {
            await this.search(false, {
                sortmode: 'rand', searchstr: '', tags: []
            });
        },
        async search(keepPage = false, params = {}) {
            this.loading = true;
            if (this.searchHandle) this.searchHandle.cancel();
            this.searchHandle = axios.CancelToken.source();
            if (!keepPage) {
                this.page = 1;
            }
            const { sortmode, colormode, searchstr, selectedTags, page } = this;
            const tags = selectedTags.length == this.tags.length ? "[]" : JSON.stringify(selectedTags);
            const { data } = await axios
                .post("/backend/tower/list.php", createFormData({
                    sortmode, colormode, searchstr, tags, page, ...params
                }), {
                    cancelToken: this.searchHandle.token,
                });
            this.towers = data.towers;
            this.total = Number(data.total);
            this.loading = false;
        },
        switchCard() {
            this.useold = !this.useold;
            localStorage.setItem("website.useoldcard", this.useold ? "1" : "0");
        }
    },
    components: {
        MainHeader, Footer,
        MainTowerCard,
    },
};
</script>

<style>
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
body {
    background-color: #e6e6e6 !important;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.adjuster {
    width: 100%;
    @media screen and (min-width: 1000px) {
        margin: 20px auto;
    }
    @media screen and (max-width: 999px) {
        margin: 0 auto;
    }
    display: flex;
    flex-direction: column;
    align-items: center;
}
.card {
    background-color: #f6f6f6;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(18,18,18,.1);
    box-shadow: 0 1px 3px rgba(18,18,18,.1);
    margin: 6px;
}
.dashboard-card {
    transition: none;
    @media screen and (min-width: 1000px) {
        width: 1000px;
    }
    @media screen and (max-width: 999px) {
        width: 100%;
        margin-top: 0;
    }
}
.advanced-filter-btn {
    line-height: 32px;
    .ant-tag {
        font-size: 14px;
    }
}
.advanced-filter {
    padding-top: 10px;
    text-align: left;
    line-height: 24px;
    overflow: hidden;
}
.extra {
    line-height: 30px;
    > a {
        margin-left: 8px;
    }
}
.colormode {
    font-weight: bold;
    font-size: 18px;
    margin: 0px 5px;
    .switch {
        font-size: 16px;
        margin: 3px;
        cursor: pointer;
    }
}
.color-helper {
    font-size: 12px;
    color: inherit;
}
.rand {
    color: red;
    font-weight: bold;
}
.tower-list-container {
    margin: 10px 0;
    width: 100%;
}
.tower-list {
    margin: 0 auto;
    padding: 0;
    width: 94%;
    display: flex;
    flex-flow: wrap;
    justify-content: center;
    @media screen and (max-width: 600px) {
        width: 96%;
    }
}
</style>

<style scoped>
/* For demo */
.ant-carousel >>> .slick-slide {
  text-align: center;
  height: 320px;
  line-height: 320px;
  background: #364d79;
  overflow: hidden;
}

.ant-carousel >>> .slick-slide h3 {
  color: #fff;
}
</style>

<style lang="less" scoped>
.towers, .bbs {
    max-width: 1000px;
    margin: 0 auto;
}
</style>
